import { Banknote, CreditCard } from "lucide-react";
import { formatCurrency } from "@/lib/money";
import { PAYMENT_METHOD_LABELS, type PaymentMethod } from "@/lib/paymentMethod";
import { Button } from "@/components/ui/Button";
import type { GuestTabletPendingPayment } from "@/types/guestTablet";

type Props = {
  pendingPayment: GuestTabletPendingPayment;
  currency: string;
  confirming: boolean;
  onConfirm: () => void;
};

function pendingMethodLabel(method: string): string {
  return PAYMENT_METHOD_LABELS[method as PaymentMethod] ?? method;
}

export function GuestTabletPaymentConfirmBanner({
  pendingPayment,
  currency,
  confirming,
  onConfirm,
}: Props) {
  const method = pendingPayment.payment_method;
  const Icon = method === "card" ? CreditCard : Banknote;
  const methodLabel = pendingMethodLabel(method);
  const confirmLabel =
    method === "cash"
      ? "Barzahlung bestätigen"
      : method === "card"
        ? "Kartenzahlung bestätigen"
        : "Zahlung bestätigen";

  return (
    <div className="rounded-lg border border-status-orange/30 bg-status-orange/10 px-4 py-3">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="flex items-center gap-2 text-sm font-semibold text-label">
            <Icon className="h-4 w-4 shrink-0 text-status-orange" aria-hidden />
            Gast hat am Tablet {methodLabel} gewählt
          </p>
          <p className="mt-1 text-sm text-label-secondary">
            {method === "cash"
              ? "Bitte bestätigen Sie, dass der Betrag in bar eingegangen ist."
              : "Bitte bestätigen Sie, dass die Kartenzahlung erfolgreich war (ohne ZVT-Terminal)."}
          </p>
          <p className="mt-2 tabular-nums text-base font-semibold text-label">
            {formatCurrency(String(pendingPayment.amount), currency)}
          </p>
        </div>
        <Button type="button" loading={confirming} disabled={confirming} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </div>
    </div>
  );
}
